import { Suspense } from "react";
import { Outlet } from "react-router-dom";
// See components/Seo.tsx for why this imports vite-react-ssg's Head instead
// of react-helmet-async's Helmet directly.
import { Head } from "vite-react-ssg";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ORGANIZATION_SCHEMA } from "./components/Seo";

// index.html used to carry a set of data-default meta tags as a no-JS fallback,
// which this component stripped on mount once <Seo> had injected the real ones.
// Pre-rendering made both halves obsolete: every route now ships its own correct
// tags in the static HTML, so the fallbacks were pure duplicates that a non-JS
// crawler (the only audience they existed for) saw and a client-side effect could
// never help. They're gone from index.html, and so is the cleanup effect.
export default function Layout() {
  return (
    <div className="bg-brand-dark min-h-screen text-brand-light selection:bg-brand-accent selection:text-brand-light relative">
      {/* Global Textures */}
      <div className="pointer-events-none fixed inset-0 z-50 bg-noise opacity-[0.04] mix-blend-overlay"></div>
      <div className="pointer-events-none fixed inset-0 z-50 bg-paper opacity-[0.03] mix-blend-overlay"></div>

      <Head>
        <script type="application/ld+json">{JSON.stringify(ORGANIZATION_SCHEMA)}</script>
      </Head>

      <Navbar />
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton />
    </div>
  );
}
